export default {
  createShuttleReservations: 'Create Shuttle Reservations',
  routeGroup: 'Route Group',
  route: 'Route',
  riders: 'Rider(s)',
  reserveFor: 'Reserve for',
  singleDay: 'Single Day',
  period: 'Period',
  date: 'Date',
  dates: 'Dates',
  selectEndDate: 'Select end date',
  from: 'From',
  until: 'Until',
  selectGroup: 'Select group',
  selectRoute: 'Select route',
  selectRiders: 'Select riders',
  selectStop: 'Select stop',
  riderSelected: '1 rider selected',
  ridersSelected: '{0} riders selected',
  searchRiders: 'Search riders',
  noResults: 'No results',
  selectStopsForRiders: 'Select stops for riders',
  stop: 'Stop',
  selectRouteFirst: 'Select a route first',
  viewAll: 'View All ({0})',
  create: 'Create',
  ok: 'OK',
  capacityMayVary: 'Route capacity may vary. Reservations will only be created for days with available seats.',
  openEndedNote:
    'Since no end date is selected, the riders will be added as permanent riders of this route for all of its operating days.',
  dateNotOperating: 'The route does not operate on the selected date.',
  successTitle: 'Reservations Created Successfully',
  successMessage: 'The reservations have been successfully created for the selected riders.',
  successRegularTitle: 'Riders Added to Route',
  successRegularMessage: 'The selected riders have been added as permanent riders of this route.',
  addRiders: 'Add Riders',
  createReservation: 'Create Reservation',
  partialTitle: 'Reservations Partially Created',
  partialMessage: 'Some reservations could not be created:',
  riderFailed: 'The reservation could not be created for this rider.',
  // Why a rider failed, by the BE reason code (VSER-14667)
  riderNotFound: 'The rider could not be found.',
  stopNotOnRoute: 'The selected stop is not on this route.',
  campusNotOnRoute: 'The selected campus is not served by this route.',
  riderRejectedWithCode: 'The reservation was rejected (error code {0}).',
  riderUnexpectedError: 'The reservation could not be saved because of an unexpected error.',
  // Multi-campus route groups (VSER-14667)
  boardingCampus: 'Boarding campus',
  dropOffCampus: 'Drop-off campus',
  campus: 'Campus',
  automaticCampus: 'Automatic',
  automaticCampusNote:
    'This route group serves more than one campus. With Automatic, the rider keeps the campus they already use on this route, or else their own campus.',
  campusPerRider: 'Campus per rider:',
  capacityFullOn: 'No available seats on: {0}',
  notOperatingOn:
    'The route does not operate on some of the selected dates ({0}). Reservations were only created for its operating days.',
  deleteReservationTitle: 'Delete Reservation',
  deleteReservationMessage: 'Are you sure you want to delete the reservation for {0} on {1}, scheduled for {2}?',
  multiDayReservationMessage:
    'This is a multi-day reservation. Do you want to delete the selected day only or all days in this reservation?',
  delete: 'Delete',
  deleteThisDayOnly: 'Delete This Day Only',
  deleteAllDays: 'Delete All Days',
  deletedTitle: 'Reservation Deleted',
  deletedMessage: 'The reservation has been deleted for the selected day.',
  deletedAllMessage: 'All reservations of this rider on this route have been deleted.',
  notFoundTitle: 'No Reservation Found',
  notFoundMessage: 'This rider no longer has a reservation to delete. The list will be refreshed.',
  // Regular (permanent) riders of the route (VSER-14309)
  removeRiderTitle: 'Remove Rider',
  regularRiderMessage: '{0} is a regular rider of {1}. Do you want to remove them from the trip on {2}?',
  optOutExplanation:
    'Delete This Day Only removes the rider from this trip only. Opt-Out removes the rider from the route entirely: both directions and the route group.',
  optOut: 'Opt-Out',
  regularDayCancelledTitle: 'Rider Removed from Trip',
  regularDayCancelledMessage:
    'The rider has been removed from this trip only. Their other trips on this route are not affected.',
  optedOutTitle: 'Rider Opted Out',
  optedOutMessage: 'The rider has been removed from both directions of this route and from the route group.',
  // Dynamic route groups (VSER-14182)
  selectLocationsForRiders: 'Select locations for riders',
  createRequest: 'Create Request',
  selectLocation: 'Select Location',
  selectAnotherLocation: 'Select Another Location',
  preferredPickupSuffix: '(Preferred pick-up address)',
  selectLocationTitle: 'Select Location for Dynamic Shuttle Request',
  searchLocation: 'Search location',
  movePinIntoServiceArea: 'Move the pin to place it inside the service area highlighted in blue.',
  moveToServiceArea: 'Move to Service Area',
  noPreferredAddress: 'No preferred pick-up address available',
  noPreferredAddressPlacePin:
    'No preferred pick-up address available. Right-click on the map where you want to assign as rider’s pick-up/drop-off location.',
  requestsSuccessTitle: 'Reservation Requests Created Successfully',
  requestsSuccessMessage: 'The reservation requests have been successfully created for the selected riders.',
  requestsPartialTitle: 'Requests Partially Created',
  requestsPartialMessage: 'Some requests could not be created:',
  riderWaitlisted: 'Added to the waitlist (position {0}).',
  riderQuotaExceeded: 'The route group quota is full for the selected period.',
  riderRequestFailed: 'The request could not be created for this rider.',
  alreadyRequestedOn: 'Already had requests on: {0}',
  groupBeingOptimized:
    'Routes of this group are being optimized right now. Reservations can be managed once the routes are finalized.',
  cancelReservationTooltip: 'Delete reservation',
  deletingReservation: 'Deleting reservation…',
  boardingStatus: 'Boarding Status',
  cancellationTime: 'Cancellation Time',
  boardingStatuses: {
    BOARDED: 'Boarded',
    NO_SHOW: 'No Show',
    SKIPPED: 'Skipped',
    ARRIVED: 'Arrived',
    AWAITING: 'Awaiting',
  },
  errors: {
    routeNotFound: 'Route not found.',
    invalidDay: 'Invalid date selection.',
    cancelFailed: 'The reservation could not be deleted.',
    stopAlreadyServed: 'The rider’s stop on this trip has already been served, so the rider can no longer be removed from it.',
  },
};
